import type {
  ActivityArchiveResponse,
  CollectionMutationResponse,
  DeleteActivityResponse,
  DeleteCollectionResponse,
  LibraryQuery,
  LibraryResponse,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const libraryQueryRoot = ["library"] as const;

export function libraryQueryKey(query: LibraryQuery) {
  return [...libraryQueryRoot, query] as const;
}

export function loadLibrary(query: LibraryQuery): Promise<LibraryResponse> {
  const parameters = new URLSearchParams();
  if (query.search) parameters.set("search", query.search);
  if (query.collectionId) parameters.set("collectionId", query.collectionId);
  if (query.view !== "active") parameters.set("view", query.view);
  if (query.format) parameters.set("format", query.format);
  if (query.difficulty) parameters.set("difficulty", query.difficulty.toString());
  if (query.unscheduled) parameters.set("unscheduled", "true");
  const suffix = parameters.size > 0 ? `?${parameters.toString()}` : "";
  return apiRequest<LibraryResponse>(`/api/v1/library${suffix}`);
}

export function createCollection(name: string): Promise<CollectionMutationResponse> {
  return apiRequest("/api/v1/collections", {
    method: "POST",
    body: JSON.stringify({ name }),
  });
}

export function renameCollection(
  collectionId: string,
  name: string,
): Promise<CollectionMutationResponse> {
  return apiRequest(`/api/v1/collections/${collectionId}`, {
    method: "PATCH",
    body: JSON.stringify({ name }),
  });
}

export function deleteCollection(
  collectionId: string,
  unassignActivities: boolean,
): Promise<DeleteCollectionResponse> {
  return apiRequest(`/api/v1/collections/${collectionId}`, {
    method: "DELETE",
    body: JSON.stringify(unassignActivities ? { fallback: "unassign" } : {}),
  });
}

export function setActivityArchived(
  activityId: string,
  action: "archive" | "restore",
): Promise<ActivityArchiveResponse> {
  return apiRequest(`/api/v1/activities/${activityId}/${action}`, { method: "POST" });
}

export function permanentlyDeleteActivity(activityId: string): Promise<DeleteActivityResponse> {
  return apiRequest(`/api/v1/activities/${activityId}`, { method: "DELETE" });
}
